module.exports = __webpack_public_path__ + "static/img/bc-p90.ac5d9d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-p90.png
// module id = adP+
// module chunks = 0